// ─── CLIENT NAME NORMALIZATION ────────────────────────────────────────────────
// Strips legal suffixes and normalizes spacing so names match across files
// e.g. "Logistics Plus Inc " === "LOGISTICS PLUS INC-BRAZIL" → no, but
//      "Logistics Plus Inc" === "Logistics Plus Inc " → yes

const STRIP_SUFFIXES = [
  'LLC', 'L.L.C', 'L.L.C.', 'INC', 'INC.', 'LTD', 'LTD.',
  'FZE', 'FZCO', 'FZ', 'FZC', 'LLC.', 'CO.', 'CO',
  'SOLE PROPRIETORSHIP', 'S.O.C', 'SOC', 'PVT', 'PVT.',
  'GLOBAL', 'GROUP', 'TRADING', 'COMPANY', 'ENTERPRISES',
];

export function normalizeName(name) {
  if (!name) return '';
  let n = String(name)
    .toUpperCase()
    .replace(/[.\-_,()]/g, ' ')  // replace punctuation with space
    .replace(/\s+/g, ' ')         // collapse multiple spaces
    .trim();

  // Strip known legal suffixes from the end
  let changed = true;
  while (changed) {
    changed = false;
    for (const suffix of STRIP_SUFFIXES) {
      const pattern = new RegExp(`\\b${suffix}\\b\\s*$`);
      if (pattern.test(n)) {
        n = n.replace(pattern, '').trim();
        changed = true;
      }
    }
  }
  return n.trim();
}

// Build a lookup map from normalized name → original name
export function buildNameMap(names) {
  const map = {};
  for (const name of names) {
    const norm = normalizeName(name);
    if (norm) map[norm] = name;
  }
  return map;
}

// Find the best match for a name in a set of known names
export function findMatch(name, knownNamesSet) {
  const norm = normalizeName(name);
  // Exact normalized match
  if (knownNamesSet.has(norm)) return norm;
  // Starts-with match (e.g. "Axalta FZE" matches "Axalta")
  for (const known of knownNamesSet) {
    if (norm.startsWith(known) || known.startsWith(norm)) return known;
  }
  return null;
}
